import adminMenu from "./admin";
import managerMenu from "./manager";
import employeeMenu from "./employee";
import advertiserMenu from "./advertiser";
const menu = [...adminMenu, ...managerMenu, ...employeeMenu, ...advertiserMenu];
export default menu;
